"use strict";
/*
 *
 * Gère tous les fileinputs
 * On donne un sélecteur en paramètre ex : FileInput(".selecteur");
 *
 *
 * Sélectionne l'input associé au sélecteur
 * Va chercher "data-valmsg-for" dans l'html associé au nom de l'input pour les messages d'erreurs
 * Et "data-preview-for" dans l'html associé au nom de l'input pour afficher une preview
 * Dans les 2 cas il ne se passe rien s'ils sont inexistants
 *
 * Ajout de 6 fonctions en options "onInit", "onChange"et "onRemove" pour faire d'autres choses à l'initialisation ou au changement ou suppression de fichier
 *
 * */
class FileInput {
    constructor(selector, options) {
        this.formats = [];
        this.initClassName = "-isInit";
        this.file = {
            src: "",
            ext: "",
            name: ""
        };
        this.options = {
            minKo: 5,
            maxKo: 4000,
        };
        if (!$(selector).hasClass(this.initClassName)) {
            this.init(selector, options);
        }
    }
    init(selector, options) {
        if (options) {
            this.options = Object.assign(Object.assign({}, this.options), options);
        }
        this.selector = selector;
        // cherche les éléments du DOM
        this.DOM = {
            input: $(selector),
            errorWrapper: $(`[data-valmsg-for='${$(selector).attr("id")}']`),
            imageWrapper: $(`[data-preview-for='${$(selector).attr("id")}']`),
        };
        this.DOM.input.addClass(this.initClassName);
        if ($(this.selector).attr("accept") != null) {
            this.formats = $(this.selector).attr("accept").split(", ").map((format) => format.replace(".", ""));
        }
        this.addEvents();
        if (this.options.onInit) {
            this.options.onInit.bind(this)();
        }
    }
    changeFileNameText(input, filename) {
        var $container = $(input).parent();
        if ($container.find(".a-filename")) {
            $container.find(".a-filename").remove();
        }
        if (filename) {
            $container.append('<p class="a-filename"><b>Image :</b> ' + filename + ' <span class="a-filename__remove" title="Supprimez votre dessin"></span></p>');
            $(".a-filename__remove").bind("click", (e) => {
                e.preventDefault();
                this.removeFile();
            });
        }
    }
    removeFile() {
        if ($(".a-filename").get(0)) {
            $(".a-filename__remove").unbind("click");
            $(".a-filename").remove();
        }
        this.DOM.input.val("");
        this.removeImagePreview();
        if (this.options.onRemove) {
            this.options.onRemove.bind(this)();
        }
    }
    addImagePreview(src, fileExtension) {
        var div = document.createElement("div");
        if (fileExtension === "pdf") {
            var iframe = document.createElement("iframe");
            iframe.src = src;
            div.appendChild(iframe);
            this.DOM.imageWrapper.html(div);
        }
        else {
            var image = new Image();
            image.src = src;
            div.appendChild(image);
            this.DOM.imageWrapper.html(div);
        }
    }
    removeImagePreview() {
        this.DOM.imageWrapper.html("");
    }
    readURL(input, filename, fileExtension) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = (e) => {
                var src = e.target.result;
                this.file = {
                    src: src,
                    name: filename,
                    ext: fileExtension
                };
                if (this.DOM.imageWrapper.get(0)) {
                    this.addImagePreview(src, fileExtension);
                }
                this.changeFileNameText(input, filename);
                if (this.options.onChange) {
                    this.options.onChange.bind(this)();
                }
            };
            reader.readAsDataURL(input.files[0]);
        }
    }
    checkFileExtension(ext) {
        var isValid = false;
        if (this.formats.length === 0) {
            isValid = true;
        }
        else {
            this.formats.forEach((format) => {
                if (format === ext) {
                    isValid = true;
                }
            });
        }
        return isValid;
    }
    addEvents() {
        this.DOM.input.change((e) => {
            var input = e.target;
            if (input.value) {
                var file = input.files[0];
                var fileName = file.name;
                var fileSize = Math.round((file.size / 1024) * 100) / 100;
                var dotIndex = fileName.lastIndexOf(".") + 1;
                var fileExtension = fileName.substr(dotIndex, fileName.length).toLowerCase();
                var isFileExtensionValid = this.checkFileExtension(fileExtension);
                if (!isFileExtensionValid) {
                    this.DOM.errorWrapper.removeClass("field-validation-valid");
                    this.DOM.errorWrapper.addClass("field-validation-error a-message -error");
                    if (this.DOM.input.data("format-error-msg")) {
                        this.DOM.errorWrapper.html(this.DOM.input.data("format-error-msg"));
                    }
                    else {
                        var formatsErrorMessage = "Veuillez sélectionner un fichier au format";
                        this.formats.forEach((format, index) => {
                            if (index !== this.formats.length - 1) {
                                formatsErrorMessage += " " + format.toUpperCase() + ",";
                            }
                            else {
                                formatsErrorMessage += " ou " + format.toUpperCase() + ".";
                            }
                        });
                        this.DOM.errorWrapper.html(formatsErrorMessage);
                    }
                }
                else {
                    if (fileSize < this.options.minKo) {
                        this.DOM.errorWrapper.removeClass("field-validation-valid");
                        this.DOM.errorWrapper.addClass("field-validation-error a-message -error");
                        if (this.DOM.input.data("small-file-error-msg")) {
                            this.DOM.errorWrapper.html(this.DOM.input.data("small-file-error-msg"));
                        }
                        else {
                            this.DOM.errorWrapper.html("Votre fichier est trop petit. Essayez avec un autre fichier.");
                        }
                    }
                    else if (fileSize > this.options.maxKo) {
                        this.DOM.errorWrapper.removeClass("field-validation-valid");
                        this.DOM.errorWrapper.addClass("field-validation-error a-message -error");
                        if (this.DOM.input.data("big-file-error-msg")) {
                            this.DOM.errorWrapper.html(this.DOM.input.data("big-file-error-msg"));
                        }
                        else {
                            this.DOM.errorWrapper.html("Votre fichier est trop lourd. Essayez avec un autre fichier.");
                        }
                    }
                    else {
                        this.DOM.errorWrapper.removeClass("field-validation-error a-message -error");
                        this.DOM.errorWrapper.addClass("field-validation-valid");
                        this.DOM.errorWrapper.html("");
                        this.readURL(input, fileName, fileExtension);
                    }
                }
            }
        });
    }
}
;
//# sourceMappingURL=maty.fileUpload.js.map